<template>
  <el-dialog
        :title="$t('deposit.PaymentDetails')"
        :visible="visible"
        width="70%"
        top="5vh"
        append-to-body
        @close="handleClose"
    >
    <!-- 明细表格 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border height="50vh">
      <el-table-column prop="rsdRsId" :label="$t('deposit.rsId')" width="180" />
      <el-table-column prop="gwNoName" :label="$t('deposit.rsdGwNo')" width="180" />
      <el-table-column prop="rsdTrCurrency" :label="$t('deposit.rsdTrCurrency')" width="180" />
      <el-table-column prop="rsdSettCurrency" :label="$t('deposit.rsdSettCurrency')" width="180" />
      <el-table-column prop="rsdBailrate" :label="$t('deposit.rsdBailrate')" width="180" />
      <el-table-column prop="rsdTradeCount" :label="$t('deposit.rsdTradeCount')" width="180" />
      <el-table-column prop="rsdTradeAmount" :label="$t('deposit.rsdTradeAmount')" width="180" />
      <el-table-column prop="rsdRefundmentAmount" :label="$t('deposit.rsdRefundmentAmount')" width="180" />
      <el-table-column prop="rsdProtestAmount" :label="$t('deposit.rsdProtestAmount')" width="180" />
      <el-table-column prop="rsdTradeTotal" :label="$t('deposit.rsdTradeTotal')" width="180" />
      <el-table-column prop="rsdSettTotal" :label="$t('deposit.rsdSettTotal')" width="180" />
    </el-table>

    <!-- 独立的分页器 -->
    <div style="margin-top: 15px; display: flex; justify-content: flex-end;">
      <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="pagination.total"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TransferFundsDetail',
  // 2. 定义 Props
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      // 3. 定义组件内部状态
      loading: false,
      tableData: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  methods: {
    // 4. 定义方法
    async fetchData() {
      if (!this.rowId) return;
      this.loading = true;
      try {
        const res = await this.$axios.post('/api/deposit/transferFunds', {
          id: this.rowId,
          page: this.pagination.page,
          limit: this.pagination.limit
        });

        if (res.data.code === 0) {
          const responseData = res.data.data;
          this.tableData = res.data.data.records || [];
          this.pagination.total = Number(res.data.data.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询明细失败:', err);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      // 关闭时，通过 update:visible 事件通知父组件
      this.$emit('close');
      this.tableData = [];
      this.pagination.total = 0;
    },
    handleSizeChange(newLimit) {
      this.pagination.limit = newLimit;
      this.fetchData();
    },
    handleCurrentChange(newPage) {
      this.pagination.page = newPage;
      this.fetchData();
    }
  },
  watch: {
    // 5. 监听 props 变化
    visible(newVal) {
      if (newVal) {
        this.pagination.page = 1; // 每次打开强制回到第一页
        this.fetchData();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/view/reserveSettlement/PaymentDetails.vue